<template>
  <section>
    <form>
      <FormRow :fieldNameArr="[$t('VN_CODE'), '']" :col1Required="true">
        <AutoComplete
          v-model="vnCode"
          :placeholder="$t('VN_CODE')"
          element-id="vnCode"
          @on-search="search"
          clearable
          :disabled="!canUpdate"
          slot="a"
        >
          <Option v-for="(item, index) in vnCodeSourceList" :value="item" :key="index">{{ item }}</Option>
        </AutoComplete>
        <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
      </FormRow>
      <TablePage 
        :tableWidth="windowWidth"
        :columnsList="columnsList" 
        :resultList="vnCodeList"
      ></TablePage>
    </form>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "VNCodeMaintain",
  props: {
    vnCodeList: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  components: {

  },
  data() {
    return {
      vnCode: "",
      vnCodeSourceList: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          title: this.$t('VN_CODE'),
          key: "vnCode",
          maxWidth: 150,
        },
        {
          title: this.$t('COMPANY_NAME'),
          key: "companyName",
        },
        {
          title: this.$t('CITY'),
          key: "city",
          maxWidth: 250,
        },
      ]
    }
  },
  created() {
    let vueInstance = this
    vueInstance.$vendorHttp
      .get("/group-account/" + vueInstance.group.uuid + "/data-control/VN_CODE")
      .then((response) => {
        response.data._embedded.dataControlResourceList.forEach((vnCode) => {
          buildVnCode(vueInstance, vnCode)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters(["getUserProfile", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search() {
    },
    add() {
      const vueInstance = this
      if (vueInstance.validation() == null) {
        vueInstance.toggleLoading(true)
        vueInstance.$authHttp
          .get("data-control/VN_CODE?vnCode=" + vueInstance.vnCode)
          .then((response) => {
            vueInstance.toggleLoading(false)
            buildVnCode(vueInstance, response.data)
            vueInstance.$linkDataControl(
              vueInstance,
              "VN_CODE",
              response.data.objectKey,
              vueInstance.group.code,
              "GROUP_USER"
            )
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
      this.vnCode = ""
    },
    remove(item) {
      const vueInstance = this
      AlertDelete(vueInstance, `VN代碼 ${item.vnCode}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(
            vueInstance,
            "VN_CODE",
            item.vnCode,
            vueInstance.group.code,
            "GROUP_USER"
          )
          vueInstance.vnCodeList.splice(item._index, 1)
        })
        .catch(() => {})
    },
    validation() {
      const vueInstance = this
      let errorMessage = ""
      if (!vueInstance.vnCode) {
        errorMessage += "請選擇 VN Code <br>"
      }
      let temp = vueInstance.vnCodeList.filter(function (item, index, array) {
        return item.vnCode == vueInstance.vnCode
      })
      if (temp.length > 0) {
        errorMessage += "重複 VN Code <br>"
      }

      if (errorMessage) {
        return AlertInfo(vueInstance, errorMessage).then(() => {})
      }
      return null
    }
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_VN_CODE_RELATION_AREA_MODIFIABLE")
      )
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
}

function buildVnCode(vueInstance, vnCode) {
  let companyName = ""
  let city = ""
  vnCode.attributes.forEach((attribute) => {
    if (attribute.key == "city") {
      city = attribute.value
    }
    if (attribute.key == "companyName") {
      companyName = attribute.value
    }
  })
  vueInstance.vnCodeList.push({ vnCode: vnCode.objectKey, companyName: companyName, city: city })
}
</script>

<style scoped></style>
